function contractData(state) {
  return state.settings.contractData
}

function invoiceYears(state) {
  return state.settings.invoices
    .reduce((years, invoice) => {
      const invoiceYear = invoice.date.getFullYear()
      if (years.indexOf(invoiceYear) === -1) {
        years.push(invoiceYear)
      }
      return years
    }, [])
    .sort((a, b) => {
      return b - a
    })
}

function selectedInvoiceYear(state, getters) {
  if (!state.settings.selectedInvoiceYear) {
    return getters.invoiceYears[0]
  }

  return state.settings.selectedInvoiceYear
}

function invoicesOfYear(state, getters) {
  return (year = false) => {
    if (!year) {
      year = getters.selectedInvoiceYear
    }

    return state.settings.invoices
      .filter((invoice) => {
        return invoice.date.getFullYear() === parseInt(year, 10)
      })
      .sort((a, b) => {
        return a.date - b.date
      })
  }
}

function consumerPricesLoaded(state) {
  return state.cube.consumerPricesLoaded
}

function consumerPrices(state) {
  return (cubeName) => {
    return state.cube.consumerPrices[cubeName]
  }
}

function producerPrices(state) {
  return (cubeName) => {
    return state.map.globalProducerPrices[cubeName]
  }
}

function defaultSellingPrice(state) {
  return state.settings.producerSettings.defaultSellingPrice
}

function nextDefaultSellingPrice(state) {
  return state.settings.producerSettings.nextDefaultSellingPrice.price
}

function nextDefaultSellingPriceDate(state) {
  return state.settings.producerSettings.nextDefaultSellingPrice.date
}

export default {
  contractData,
  invoiceYears,
  selectedInvoiceYear,
  invoicesOfYear,
  consumerPricesLoaded,
  consumerPrices,
  producerPrices,
  defaultSellingPrice,
  nextDefaultSellingPrice,
  nextDefaultSellingPriceDate,
}
